module.exports = __webpack_public_path__ + "static/media/p1_s4.bf4ab130.ogg";